<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import SiteFormPage from '@/views/apps/sites/SiteFormPage.vue'

definePage({ meta: { ...PageMeta.Sites.Edit.Meta, pageTitle: PageMeta.Sites.Edit.Title } })

const route = useRoute()

const siteGuid = computed(() => {
  const params = route.params as Record<string, string | string[] | undefined>
  const guid = params.guid

  return Array.isArray(guid) ? guid[0] : guid
})
</script>

<template>
  <SiteFormPage
    v-if="siteGuid"
    mode="edit"
    :site-guid="siteGuid"
  />
</template>
